import '../css/index.scss';
import DPlayer from './player';
export default DPlayer;